import React from 'react';
import { Button, OptimizedImage } from '../common';
import { useNavigate } from 'react-router-dom';

export const HeroSection: React.FC = () => {
  const navigate = useNavigate();

  const handleExplore = () => {
    const missionSection = document.getElementById('mission-section');
    if (missionSection) {
      missionSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleProducts = () => {
    navigate('/products');
    window.scrollTo(0, 0);
  };

  return (
    <section className="relative overflow-hidden min-h-screen bg-gray-100">
      {/* Full background image overlay */}
      <div className="absolute inset-0">
        <OptimizedImage
          src="/images/000.main.jpeg" 
          alt="AI collaboration illustration" 
          className="absolute inset-0 w-full h-full"
          priority={true}
          sizes="100vw"
        />
        {/* Dark overlay to ensure text readability */}
        <div className="absolute inset-0 bg-black/50 lg:bg-black/40"></div>
        {/* Gradient overlay for better text contrast */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent lg:bg-gradient-to-r lg:from-black/40 lg:to-transparent"></div>
      </div>

      <div className="relative z-10 px-8 sm:px-6 md:px-16 py-16 sm:py-16 md:py-24 lg:py-28 min-h-screen flex items-center">
        <div className="w-full max-w-2xl mx-auto lg:mx-0">
          <div className="text-center lg:text-left">
            <h1 className="mb-8 text-[48px] leading-[1.15] sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold font-gabarito text-white md:mb-6 drop-shadow-2xl">
              Making AI <span className="text-[#C97B5A]">Useful</span><br />
              for <span className="text-[#C97B5A]">Everyone</span>
            </h1>
            <p className="text-white text-[17px] leading-[1.6] sm:text-base md:text-lg lg:text-xl mb-12 sm:mb-8 px-4 sm:px-0 sm:max-w-xl mx-auto lg:mx-0 drop-shadow-lg">
              We're building the future of human-AI collaboration. Our mission is to create AI that truly serves humanity, simplifying complex tasks and making the impossible possible.
            </p>
            <div className="flex flex-row gap-4 justify-center lg:justify-start px-4 sm:px-0">
              <Button variant="secondary" size="lg" onClick={handleExplore} className="flex-1 sm:flex-initial">
                Explore
              </Button>
              <Button variant="primary" size="lg" onClick={handleProducts} className="flex-1 sm:flex-initial">
                Products
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};